<template>
    <hts-user
        :id="id"
        :type="type"
        :size="size"
        :editable="editable"
        :show-info="showInfo"
        :show-popup="showPopup" />
</template>

<script setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const { id, type, size, editable, showInfo, showPopup } = toRefs(params?.value || {})
</script>
